import React, { Component } from 'react';
import CareersComponent from '../../_Componants/Careers/Careers';

class Careers extends Component{
    render(){
        return (
            <div>
                <CareersComponent/>
            </div>
        )
    }
}

export default Careers;